import React, { useState, useEffect } from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Menu, MenuItem } from '@mui/material'
import { fetchData, deleteData, patchData } from '../../../../../pages/Utils/Baseurl';
import MaterialInput from '../../../../../components/MaterialInput'
import { useSnackbar } from '../../../../../components/SnackbarProvider';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import './index.css'
import MaterialButton from '../../../../../components/MaterialButton';
import MaterialDatePicker from '../../../../../components/MaterialDatePicker';
import MaterialTypography from '../../../../../components/MaterialTypography';
import { useLoading } from '../../../../../context/loadingcontext';

const ActivePlans = ({ search, filter, selectedProject, onEdit, refreshTrigger }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [testPlanList, setTestPlanList] = useState([]);
    const { setCirleLoading } = useLoading();
    const { showSnackbar } = useSnackbar();



    const fetchTestPlans = React.useCallback(async () => {
        setCirleLoading(true);
        try {
            const response = await fetchData(`api/testplan/?project_id=${selectedProject.value}&flag=1`);
            if (response && response.status) {
                setTestPlanList(response.data);
            } else {
                setTestPlanList([]);
            }
        } catch (error) {
            console.error("Error fetching test plans:", error);
            setTestPlanList([]);
        } finally {
            setCirleLoading(false);
        }
    }, [selectedProject, setCirleLoading]);

    useEffect(() => {
        if (selectedProject?.value) {
            fetchTestPlans();
        }
    }, [selectedProject, fetchTestPlans, refreshTrigger]);

    const handleMenuOpen = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleStartTestPlan = () => {
        handleMenuClose();
        setOpenDialog(true);
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleDelete = async () => {
        if (!selectedRow) return;

        setCirleLoading(true);
        try {
            const response = await deleteData(`api/testplan/${selectedRow.id}/`);
            if (response) {
                showSnackbar('Test Plan deleted successfully', 'success');
                fetchTestPlans();
            }
        } catch (error) {
            console.error("Error deleting test plan:", error);
            showSnackbar(error.response?.data?.message || 'Failed to delete Test Plan', 'error');
        } finally {
            setCirleLoading(false);
            handleMenuClose();
        }
    };

    const handleStart = async () => {


        setCirleLoading(true);
        try {
            const payload = {
                actual_start_date: startDate,
                actual_end_date: endDate
            };
            const response = await patchData(`api/testplan/${selectedRow.id}/`, payload);
            if (response) {
                showSnackbar('Test Plan started successfully', 'success');
                fetchTestPlans();
                handleCloseDialog();
            }
        } catch (error) {
            console.error("Error starting test plan:", error);
            showSnackbar(error.response?.data?.message || 'Failed to start Test Plan', 'error');
        } finally {
            setCirleLoading(false);
        }
    }

    return (
        <>
            <Grid container spacing={2} direction='column' mt={1.5}>
                <Grid size={{ xs: 12 }} sx={{ paddding: 1.5 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingX: 1 }}>
                        <MaterialInput
                            label='Search the test plans here..'
                            placeholder='Serach the test plans here..'
                            size='small'
                            value={search}
                            sx={{ maxWidth: '300px' }}
                        />
                    </Box>

                </Grid>
                <Grid size={{ xs: 12 }}>
                    <div className="table-container">
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>TITLE</th>
                                    <th>DURATION</th>
                                    {/* <th>TAGS</th> */}
                                    <th>OWNER</th>
                                    <th>PROGRESS</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {testPlanList.map((row) => (
                                    <tr key={row.id} className="table-row">
                                        <td className="id-cell">{row.plan_id}</td>
                                        <td>
                                            <div className="title">
                                                <span className="title-text">{row.title}</span>
                                                <span className="description">{row.status}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="duration">
                                                <span>{row.duration}</span>
                                                {row.overdue && <span className="badge overdue">{row.overdue}</span>}
                                            </div>
                                        </td>
                                        {/* <td>{row.tags}</td> */}
                                        <td>
                                            <span className="owner-name">{row.owner_name}</span>
                                        </td>
                                        <td>
                                            <div className="progress-container">
                                                <div className="progress-bar">
                                                    <div
                                                        className="progress-fill"
                                                        style={{ width: `${row.progress}% ` }}
                                                    ></div>
                                                </div>
                                                <span className="progress-text">{row.progress}%</span>
                                            </div>
                                        </td>
                                        <td className="menu-cell">
                                            <MoreVertIcon
                                                className="menu-icon"
                                                onClick={(e) => handleMenuOpen(e, row)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                {testPlanList.length === 0 && (
                                    <tr>
                                        <td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                                            No test plans found for the selected project.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            PaperProps={{
                                style: { borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" },
                            }}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                        >
                            <MenuItem onClick={handleStartTestPlan}>Start Test Plan</MenuItem>
                            <MenuItem onClick={() => {
                                handleMenuClose();
                                if (onEdit) onEdit(selectedRow);
                            }}>Edit Test Plan</MenuItem>
                            <MenuItem onClick={handleDelete} sx={{ color: "red", backgroundColor: "rgba(255, 0, 0, 0.1)" }}>Delete</MenuItem>
                        </Menu>
                    </div>
                </Grid>
            </Grid>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '12px' }}>Start Test Plan</DialogTitle>
                <DialogContent>
                    <Grid container direction='row' spacing={1}>
                        <Grid size={{ xs: 5 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <MaterialTypography variant="caption" color='secondary'>Start Date<span style={{ color: 'red' }}>*</span></MaterialTypography>
                                <MaterialDatePicker
                                    label="Start Date"
                                    size="small"
                                    value={startDate}
                                    onChange={(selectedDates, dateStr) => setStartDate(dateStr)}
                                    input={{
                                        value: startDate,
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 2 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <p>to</p>
                        </Grid>
                        <Grid size={{ xs: 5 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <MaterialTypography variant="caption" color='secondary'>End Date<span style={{ color: 'red' }}>*</span></MaterialTypography>
                                <MaterialDatePicker
                                    label="End Date"
                                    size="small"
                                    value={endDate}
                                    onChange={(selectedDates, dateStr) => setEndDate(dateStr)}
                                    input={{
                                        value: endDate,
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignContent: 'center', backgroundColor: '#B1CAE5', padding: 1, borderRadius: 2 }}>
                                <MaterialTypography variant="caption" color='dark'>Note: You will be able to track all the test runs and test cases once you have started this Test Plan</MaterialTypography>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <MaterialButton variant="outlined" size='small' color="secondary" onClick={handleCloseDialog}>
                        Cancel
                    </MaterialButton>
                    <MaterialButton
                        onClick={handleStart}
                        size='small'
                        variant="contained"
                        color="dark"
                    >
                        Start
                    </MaterialButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ActivePlans
